import "./App.scss";
import MainPage from "./pages/MainPage/MainPage";

function App() {
  return (
    <>
      <header class="header-resume pt-3 pb-2">
        <div class="container">
          <h2 class="h2-heading">Resume | Starovojtova Agnia</h2>
        </div>
      </header>
      <MainPage></MainPage>
    </>
  );
}

export default App;
